import React, { useEffect, useState } from 'react'
import KeyboardBackspaceIcon from '@mui/icons-material/KeyboardBackspace';
import { useLocation, useNavigate } from 'react-router-dom';
import { Box, Button, FormControl, FormControlLabel, Radio, RadioGroup, Typography } from '@mui/material';
import correct from '../../../assets/icons/e-learning/user/correct.svg'
import styles from '../elearning.module.css'
import * as api from '../../services/api'
import Loader from 'components/Loader';

function TestAfterClass() {
    const navigate = useNavigate()
    const location = useLocation()
    const [loading, setLoading] = useState(false)

    const [detail, setDetail] = useState([])
    const [question, setQuestion] = useState([])
    const [option, setOption] = useState([])
    const [option1, setOption1] = useState([])
    const [optionAnswer, setOptionAnswer] = useState([])

    if (!location.state) {
        location.state = { button: "1" };
    }

    useEffect(() => {
        let data = location.state.item
        // console.log(data)
        setDetail(data)
        if (data['post_test_form'] === null) {
            setQuestion([])
        } else {
            setQuestion(data['post_test_form'])
        }
    }, [])

    const handleButton = (number) => {
        navigate('/testAfterClass', { state: { button: number } });
    };

    const handleChooseChoice = (event, index, item) => {
        // console.log(item)
        const { value } = event.target
        const filteredItems = item['question_answer'].filter((item) =>
            item.name === value
        )
        option1[index] = parseInt(filteredItems[0]['value'])
        setOption1([...option1])

        optionAnswer[index] = filteredItems[0]
        setOptionAnswer([...optionAnswer])

        option[index] = event.target.value
        setOption([...option])
    }

    const handleClickSaveTest = () => {
        if (option1.length === question.length) {
            let inform = {
                "e_learning_code": detail['e_learning_code'],
                "e_learning_group_code": detail['e_learning_group_code'],
                "test_type": "post_test",
                "question": question,
                "answer": optionAnswer,
                // "answer": option1,
                "score": option1.reduce((accumulator, currentValue) => parseInt(accumulator) + parseInt(currentValue), 0)
            }
            console.log(inform)
            newTestRecord(inform)
        } else {
            alert('กรุณาทำแบบทดสอบให้ครบทุกข้อ')
        }
    }

    const newTestRecord = async (data) => {
        setLoading(true)
        let res = await api.newTestRecord(data)
        setLoading(false)
        if (res) {
            if (res['data']['code'] === 200) {
                handleButton("2")
            } else {
                //alert(res['data']['message'])
            }
        } else {
            alert('ไม่ตอบสนอง')
        }
    }

    return (
        <>
            <Loader loading={loading} />
            <Box sx={{ display: 'grid', gridGap: '10px' }}>
                <Box sx={{
                    display: 'flex',
                    alignItems: 'center',
                    gridGap: '10px'
                }}>
                    <KeyboardBackspaceIcon sx={{ fontSize: '20px' }} />
                    <Box sx={{
                        cursor: 'pointer'
                    }}
                        onClick={() => { navigate('/manageUserELearning') }}
                    >กลับไป ห้องเรียนออนไลน์</Box>
                </Box>

                <Box>
                    <Typography sx={{
                        fontWeight: 600,
                        fontSize: '20px'
                    }}>{detail['e_learning_name']}</Typography>
                </Box>

                <Box>
                    <Typography>แบบทดสอบหลังเรียน</Typography>
                </Box>

                {location.state.button === "1" ? (
                    <>
                        <Box sx={{
                            border: '1px solid #478F96',
                            borderRadius: '10px',
                            padding: '20px',
                            display: 'grid',
                            gridGap: '10px'
                        }}>
                            {question.map((item, index) => (
                                <Box key={index}>
                                    <Typography sx={{ fontWeight: 500 }}>ข้อที่{index + 1}. {item['question_name']}</Typography>
                                    <Box sx={{ marginLeft: '5%' }}>
                                        <FormControl>
                                            <RadioGroup
                                                value={option[index] ? option[index] : ''}
                                                onChange={(e) => { handleChooseChoice(e, index, item) }}
                                            >
                                                {item['question_answer'].map((i, idx) => (
                                                    <FormControlLabel key={idx} value={i['name']} control={<Radio />} label={i['name']} />
                                                ))}
                                            </RadioGroup>
                                        </FormControl>
                                    </Box>
                                    <Box sx={{ borderTop: '1px solid #D9D9D9' }}></Box>
                                </Box>
                            ))}
                        </Box>
                        <Box sx={{ display: 'flex', justifyContent: 'end' }}>
                            <Button variant='contained' onClick={() => { handleClickSaveTest() }}>บันทึก</Button>
                        </Box>
                    </>
                ) : null}

                {location.state.button === "2" ? (
                    <>
                        <Box sx={{
                            border: '1px solid #478F96',
                            borderRadius: '10px',
                            padding: '20px'
                        }}>
                            <Box sx={{
                                display: 'grid',
                                gridGap: '10px',
                                justifyItems: 'center',
                                margin: '40px 0'
                            }}>
                                <img src={correct} className={styles.correct} />
                                <Typography sx={{ fontWeight: 600 }}>บันทึกแบบทดสอบหลังเรียนแล้ว</Typography>
                                <Box sx={{
                                    border: '1px solid #C8EBEB',
                                    borderRadius: '10px',
                                    padding: '20px',
                                    backgroundColor: '#C8EBEB'
                                }}>
                                    {option1.reduce((accumulator, currentValue) => parseInt(accumulator) + parseInt(currentValue), 0)} / {question.length}
                                </Box>
                                <Typography>สามารถตรวจสอบประวัติการเรียนได้ที่หน้าแรกของเมนู</Typography>
                            </Box>
                        </Box>
                        <Box sx={{ display: 'flex', justifyContent: 'center' }}>
                            <Button variant='contained' onClick={() => { navigate('/manageUserELearning') }}>กลับไปหน้า ห้องเรียน</Button>
                        </Box>
                    </>
                ) : null}

            </Box >
        </>
    )
}

export default TestAfterClass
